import React, { useState } from "react";
import { useStore } from "store";
import { useWindowDimensions } from "resources/BrowserManager";
import CONSTANTS from "shared/constants";
import strings from "resources/strings";
import { Flex, Space, Typography, Button, Modal, message, theme } from "antd";
const { Text } = Typography;

import ApiManager from "resources/ApiManager/api";

import "./style.scss";
const styleWrapperClass = "plan";

function ModalSubscriptionResume({ rfc, type }) {
  const { isSmallView } = useWindowDimensions();

  const { token: theme_token } = theme.useToken();

  const user = useStore((state) => state.user);
  const setUser = useStore((state) => state.setUser);
  const updateUserRfc = useStore((state) => state.updateUserRfc);

  const userHasMultipleRfcs =
    Object.values(user.rfcs).filter((rfc) => rfc.plan_name !== "free").length >
    1;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHandlingRequest, setIsHandlingRequest] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsHandlingRequest(false);
    setIsModalOpen(false);
  };

  const handleOk = async () => {
    setIsHandlingRequest(true);

    //Update subscription
    let apiRes = await ApiManager.postSubscriptionUpdate(rfc, "free");

    //Silently return when error was for session expired, as the api handler will handle the message and redirection to /login
    if (apiRes.response.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED) {
      return;
    }

    if (apiRes.response.code === -1 || apiRes.response.code !== 2000) {
      setIsHandlingRequest(false);
      message.error(strings.alertUnexpectedError);
      return;
    }

    const updatedRfc = apiRes.data.rfcs[0];
    updateUserRfc(updatedRfc);

    //Get updated user
    apiRes = await ApiManager.getUser();

    //Silently return when error was for session expired, as the api handler will handle the message and redirection to /login
    if (apiRes.response.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED) {
      return;
    }

    if (apiRes.response.code === -1 || apiRes.response.code !== 2000) {
      return;
    }

    const user = apiRes.data.user;
    setUser(user);

    message.success(strings.alertSubscriptionCancelSuccess, 10);
  };

  const description = userHasMultipleRfcs ? (
    <Space direction="vertical">
      <Text>
        Al cancelar tu plan de subscripción para este RFC, pasará inmediatamente
        al plan Demo, y perderás los beneficios del plan actual.
      </Text>
      <Text>
        Se ajustará el saldo no usado remanente para el pago de tus otros planes
        de subscripción en tu siguiente periodo.
      </Text>
    </Space>
  ) : (
    <Text>
      Al cancelar tu plan de subscripción, este seguirá activo hasta el término
      del periodo actual. Podrás seguir utilizando los beneficios de tu plan
      hasta esta fecha. No se harán cargos nuevos a tu cuenta.
    </Text>
  );

  const buttons = (
    <>
      <Button
        danger
        type="primary"
        loading={isHandlingRequest}
        onClick={handleOk}
      >
        Cancelar mi subscripción
      </Button>
      <Button
        type="primary"
        disabled={isHandlingRequest}
        onClick={handleCancel}
      >
        Continuar con mi subscripción
      </Button>
    </>
  );

  const buttonsContainer = isSmallView ? (
    <Flex vertical justify="flex-end" gap={20}>
      {buttons}
    </Flex>
  ) : (
    <Flex justify="flex-end" gap={10}>
      {buttons}
    </Flex>
  );

  return (
    <div className={styleWrapperClass}>
      {type === "downgrade" ? (
        <Button type="primary" onClick={showModal}>
          Seleccionar
        </Button>
      ) : (
        <Text
          onClick={showModal}
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            color: theme_token.colorPrimary,
          }}
        >
          Cancelar
        </Text>
      )}
      <Modal
        title="Cancelar subscripción"
        open={isModalOpen}
        onCancel={handleCancel}
        width={560}
        destroyOnClose={true}
        footer={null}
        maskClosable={!isHandlingRequest}
        closable={!isHandlingRequest}
      >
        <Flex vertical gap={30}>
          <Flex vertical gap={10}>
            <Text style={{ fontSize: "20px", fontWeight: "bold" }}>{rfc}</Text>
            <Text>{description}</Text>
          </Flex>
          {buttonsContainer}
        </Flex>
      </Modal>
    </div>
  );
}

export default ModalSubscriptionResume;
